import './lakehouse/style';
import FormStructure from './lakehouse/form_structure';

export default FormStructure;